import { dateTimeCurrent } from 'core/util/datetime';
import { range } from 'lodash';
import * as Types from '../definitions';

const nowIsoString = dateTimeCurrent();

const compactClaimDetail: Types.CompactClaimDetail = {
    claimId: '',
    claimNumber: 0,
    firstName: '',
    lastName: '',
    address1: '',
    rewardAmountTotal: 0,
    promotionName: '',
    submissionDate: nowIsoString,
};

export const mockCompactClaimDetails: Types.CompactClaimDetail[] = range(1, 5).map((i) => ({
    claimId: `${1000 + i}`,
    claimNumber: i * 2,
    firstName: `First${i}`,
    lastName: `Last${i}`,
    address1: `50${i} West Eaton Lane`,
    rewardAmountTotal: i * 5,
    promotionName: `promotion number ${i}`,
    submissionDate: nowIsoString,
}));

export const mockCompactClaimDetailSearchResponse = {
    totalResults: mockCompactClaimDetails.length,
    results: mockCompactClaimDetails,
};

export default compactClaimDetail;
